// extracted by mini-css-extract-plugin
export default {"App":"App_App__I9jfv","App-logo":"App_App-logo__qhWlT","App-logo-spin":"App_App-logo-spin__ezFXC","App-header":"App_App-header__6AlwT","App-link":"App_App-link__uxtT6"};